import { Typography } from "@mui/material";
import React from "react";

const Pay = () => {
  return (
    <div style={{ marginTop: "20px", padding: "15px" }}>
      <Typography variant="h6">Paying system is comming soon</Typography>
    </div>
  );
};

export default Pay;
